// Save an edited list of child rows (rules, mappings, master rules) against
// per-row REST endpoints, and return the state the editor should keep.
//
// - Every row created gets its server id back, so a second Save UPDATES it
//   instead of creating a duplicate (the old bug: new rows never got an id).
// - Deletes run only after all creates/updates succeeded; a row already gone
//   (404) counts as deleted.
// - On a partial failure nothing is deleted and the ids that DID save are kept,
//   so a retry can't duplicate them. The error is re-thrown for the caller.
export async function saveCollection(rows, originalIds, { payload, create, update, remove }) {
  const results = await Promise.allSettled(
    rows.map((r, idx) => (r.id ? update(r.id, payload(r, idx)) : create(payload(r, idx)))),
  );
  const saved = rows.map((r, i) => (results[i].status === 'fulfilled' && results[i].value?.id
    ? { ...r, id: results[i].value.id }
    : r));
  const failed = results.find((res) => res.status === 'rejected');
  const savedIds = saved.filter((r) => r.id).map((r) => r.id);
  if (failed) {
    return { rows: saved, ids: [...new Set([...originalIds, ...savedIds])], error: failed.reason };
  }
  const keep = new Set(savedIds);
  const toDelete = originalIds.filter((id) => !keep.has(id));
  const deletions = await Promise.allSettled(toDelete.map((id) => remove(id)));
  const delFailed = deletions.find((d) => d.status === 'rejected' && d.reason?.response?.status !== 404);
  const stillThere = toDelete.filter((id, i) => deletions[i].status === 'rejected'
    && deletions[i].reason?.response?.status !== 404);
  return { rows: saved, ids: [...savedIds, ...stillThere], error: delFailed?.reason };
}
